import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalDateRange,
  zodOptionalId,
  zodOptionalString,
  zodPage,
} from 'routes/routeUtils';
import { z } from 'zod';

export const adminKonnectTradesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/konnect',
  validateSearch: z.object({
    page: zodPage,
    tab: z.enum(['new', 'published', 'archived', 'all']).default('all'),
    query: zodOptionalString,
    pharmacyId: zodOptionalId,
    labId: zodOptionalId,
    createdAtRange: zodOptionalDateRange,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/LabTrades/Konnect/AdminKonnectTradesPage/AdminKonnectTradesPage').then(
    (d) => d.Route
  )
);
